export const SHIPMENT_NOT_FOUND_ERROR = 'Shipment not found';
